import type { AppRouteGroup } from 'app/store/components/NavigationUtils';

import InvoicesConfig from './invoices/InvoicesConfig';
import KpisConfig from './kpis/KpisConfig';
import MailsConfig from './mails/MailsConfig';
import PhonesConfig from './phones/PhonesConfig';
import PhoneCallsConfig from './phonecalls/PhoneCallsConfig';
import SocialNetworksConfig from './socialnetworks/SocialNetworksConfig';
import TagsConfig from './tags/TagsConfig';
import WebsitesConfig from './websites/WebsitesConfig';

const submodulesConfigs: AppRouteGroup[] = [
	InvoicesConfig,
	KpisConfig,
	MailsConfig,
	PhonesConfig,
	PhoneCallsConfig,
	SocialNetworksConfig,
	TagsConfig,
	WebsitesConfig
];

export default submodulesConfigs;
